export default class PositionManager {
  constructor(controller) {
    this.controller = controller
  }

  updatePositions(event) {
    const rows = Array.from(event.to.querySelectorAll('tr'))

    rows.forEach((row, index) => {
      this.updateRowPosition(row, index + 1)
    })
  }

  updateRowPosition(row, position) {
    const positionSpan = row.querySelector('.position-number')
    if (positionSpan) {
      positionSpan.textContent = position
    }

    const positionInput = row.querySelector('[data-images-field-target="positionInput"]')
    if (positionInput) {
      positionInput.value = position
    } else {
      const attachmentId = row.getAttribute('data-attachment-id')
      if (attachmentId) {
        this.createPositionInput(attachmentId, position)
      }
    }
  }

  createPositionInput(attachmentId, position) {
    const existingInput = document.querySelector(`input[name="${this.controller.attributeNameValue}_positions[${attachmentId}]"]`)
    if (existingInput) {
      existingInput.remove()
    }

    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = `${this.controller.attributeNameValue}_positions[${attachmentId}]`
    input.value = position
    input.dataset.imagesFieldTarget = 'positionInput'
    this.controller.element.appendChild(input)
  }

  updateAllPositionNumbers() {
    this.controller.imageRowTargets.forEach((row, index) => {
      const positionSpan = row.querySelector('.position-number')
      if (positionSpan) {
        positionSpan.textContent = index + 1
      }
    })
  }
}